import React, { useCallback } from 'react';
import PropTypes from 'prop-types';
import Tooltip from '@material-ui/core/Tooltip';
import { SettingsOverscan } from '@material-ui/icons';

import { translate } from 'services/i18nService';

import styles from './Controls.css';


const TheatreMode = ({ onTheatreMode, videoAndChatWrapper }) => {
  const checkCallback = useCallback((prop) => prop && typeof prop === 'function', []);

  const handleTheatreMode = useCallback(() => {
    if (checkCallback(onTheatreMode)) {
      onTheatreMode();
    }
  }, [checkCallback, onTheatreMode]);

  return (
    <Tooltip
      PopperProps={{ container: videoAndChatWrapper }}
      placement="top"
      title={translate('v2profile.player.controls.theatre.mode')}
    >
      <SettingsOverscan className={styles.rightControlsItem} onClick={handleTheatreMode} />
    </Tooltip>
  );
};

TheatreMode.propTypes = {
  videoAndChatWrapper: PropTypes.object.isRequired,
  onTheatreMode: PropTypes.func.isRequired,
};

export default TheatreMode;
